<template>
  <div class="standard-page v-flex">
    <div class="page-contents">
      <h2>Create Message Template</h2>

      <b-form @submit.prevent="handleSubmit" class="view-form">
        <div class="fields">
          <b-form-group
            label="Template Name"
            label-for="template_name"
            class="h-form-group"
          >
            <div>
              <b-form-input v-model="template_name" trim></b-form-input>
            </div>
          </b-form-group>
          <div class="text-danger field-errors">

          </div>

          <b-form-group
            label="Description"
            label-for="description"
            class="h-form-group"
          >
            <div>
              <b-form-input v-model="description" trim></b-form-input>
            </div>
          </b-form-group>
          <div class="text-danger field-errors">

          </div>

          <b-form-group
            label="Message Template"
            label-for="sms_body"
            class="h-form-group"
          >
            <div>
              <b-form-textarea v-model="sms_body" trim></b-form-textarea>
            </div>
          </b-form-group>
          <div class="text-danger field-errors">

          </div>

          <LineBreak />

          <div class="form-actions fields">
            <b-button @click="handleCancel" size="sm" variant="outline-danger">
              Cancel
            </b-button>
            <b-button size="sm" type="submit">
              Create Message Template
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import LineBreak from '@/components/Elements/LineBreak/LineBreak.vue'
import axios from '@/utils/init-axios'
import endpoints from '@/utils/endpoints.js'

export default {
  components: {
    LineBreak
  },
  data() {
    return {
      template_name: '',
      description: '',
      sms_body: '',
      errors: {}
    }
  },
  methods: {
    handleCancel() {
      this.$router.push({ name: 'MessageTemplateList' })
    },
    handleSubmit() {
      this.errors = {}
      const request_body = {
        name: this.template_name,
        description: this.description,
        sms_body: this.sms_body
      }
      axios
        .post(
          endpoints.createMessageTemplate(this.$route.params.merchantID),
          request_body
        )
        .then(res => {
          this.$router.push({ name: 'MessageTemplateList' })
        })
        .catch(err => {
          if (err?.response?.data) {
            console.log('error.response.data', err.response.data)
            this.errors = err.response.data
          } else {
            console.log('unknown error', err)
          }
        })
    }
  }
}
</script>
